import React from 'react'
import { Accordion, Card, Button } from 'react-bootstrap';




const CsAccordion = ({customStyle,indexAccordionUnit}) => {
    return (
        <Accordion className={`rn-accordion-style ${customStyle}`} defaultActiveKey="0">
            {indexAccordionUnit.map((data,index) => (
                <Card key={index}>
                    <Card.Header>
                    <Accordion.Toggle as={Button} variant="link" eventKey={`${data.identity}`}>
                        {data.caseTitle}
                    </Accordion.Toggle>
                    </Card.Header>
                    <Accordion.Collapse eventKey={`${data.identity}`}>
                        <Card.Body>
                        {data.caseCore}
                        </Card.Body>
                    </Accordion.Collapse>
                </Card>
                ))}
        </Accordion>
    )
}
export default CsAccordion

